import { FC } from 'react';

const getColourClasses = (hasError: boolean) => {
  return hasError
    ? ['bg-error-300', 'bg-error-100']
    : ['bg-secondary-300', 'bg-neutral-100'];
};

const LoadingBar: FC<{
  percentage: number;
  hasError?: boolean;
}> = ({
  percentage = 0,
  hasError = false
}: {
  percentage: number;
  hasError?: boolean;
}) => {
  const [barColourClass, backgroundColourClass] = getColourClasses(hasError);

  return (
    <>
      <div className={`w-full rounded h-2 ${backgroundColourClass}`}>
        <div
          style={{ width: `${percentage}%` }}
          className={`h-2 transition-all rounded ${barColourClass}`}
        ></div>
      </div>
    </>
  );
};

export default LoadingBar;
